import $ from 'jquery'
import './components/gmap/markerclusterer'
import { pathOr } from 'ramda'
import 'custom-event-polyfill'
import GmapObject, {mapIDs} from './components/gmap/GmapObject'
import { pushDestinationMapMarker, pushDestinationMapLinks } from './helpers/gtm'
import generateSvgBtoa from './helpers/generateSvgBtoa'

export const mapZoomTextIn = pathOr('', ['drupalSettings', 'widgets', 'mapZoom', 'textFullScreen'], window)
export const mapZoomTextOut = pathOr('', ['drupalSettings', 'widgets', 'mapZoom', 'textZoomOut'], window)

export default (
  destinationMap,
  destinationMapSettings = {},
) => {
  let map

  function canGoFullscreen() {
    const el = document.body
    const check = typeof el.requestFullscreen !== 'undefined'
        || typeof el.mozRequestFullScreen !== 'undefined'
        || typeof el.webkitRequestFullscreen !== 'undefined'
        || typeof el.msRequestFullscreen !== 'undefined'
        || typeof document.exitFullscreen !== 'undefined'
        || typeof document.mozCancelFullScreen !== 'undefined'
        || typeof document.webkitExitFullscreen !== 'undefined'

    return check
  }

  function getPinSVG() {
    const parser = new DOMParser();
    const pin = parser.parseFromString(`
    <svg width="21" height="30" viewBox="0 0 21 30" xmlns="http://www.w3.org/2000/svg" class="map-custom-pin">
      <path d="M10.4184 29.2971L10.2548 29.1416C10.1511 29.0461 0 19.3777 0 10.4184C0 4.67193 4.67464 0 10.4184 0C16.1622 0 20.8368 4.67465 20.8368 10.4184C20.8368 19.3777 10.683 29.0461 10.5821 29.1416L10.4184 29.2971Z" fill="currentColor"/>
      <path d="M10.4184 16.9477C6.81832 16.9477 3.88916 14.0185 3.88916 10.4184C3.88916 6.81832 6.81832 3.88916 10.4184 3.88916C14.0185 3.88916 16.9477 6.81832 16.9477 10.4184C16.9477 14.0185 14.0185 16.9477 10.4184 16.9477Z" fill="white"/>
    </svg>`, 'image/svg+xml')
    return pin.documentElement;
  }

  function CenterControl(controlDiv, map) {
    const controlUI = document.createElement('button')
    controlUI.style.backgroundColor = '#fff'
    controlUI.style.border = '1px solid #000'
    controlUI.style.borderRadius = '4px'
    controlUI.style.boxSizing = 'border-box'
    controlUI.style.boxShadow = '0px 2px 6px 0px rgba(0, 0, 0, 0.25)'
    controlUI.style.cursor = 'pointer'
    controlUI.style.display = 'inline-flex'
    controlUI.style.alignItems = 'center'
    controlUI.style.justifyContent = 'space-around'
    controlUI.style.marginTop = '16px'
    controlUI.style.marginRight = '16px'
    controlUI.style.height = '32px'
    controlUI.style.minWidth = '126px'
    controlUI.style.padding = '0 5px'
    controlDiv.appendChild(controlUI)

    const xmlns = 'http://www.w3.org/2000/svg'
    const boxWidth = 16
    const boxHeight = 15
    const controlIcon = document.createElementNS(xmlns, 'svg')
    controlIcon.setAttributeNS(null, 'viewBox', `0 0 ${boxWidth} ${boxHeight}`)
    controlIcon.setAttributeNS(null, 'width', boxWidth)
    controlIcon.setAttributeNS(null, 'height', boxHeight)
    controlIcon.style.display = 'block'
    controlIcon.innerHTML = `
      <path d="M9.42962 6.71185C9.39416 6.71185 9.35708 6.69735 9.32968 6.66995C9.27487 6.61514 9.27487 6.52488 9.32968 6.47008L14.2264 1.57333C14.2812 1.51853 14.3715 1.51853 14.4263 1.57333C14.4811 1.62813 14.4811 1.71839 14.4263 1.7732L9.52955 6.66995C9.50215 6.69735 9.46508 6.71185 9.42962 6.71185Z" fill="black" stroke="black"/>
      <path d="M14.5246 6.57655C14.4488 6.57655 14.386 6.5153 14.3827 6.43954L14.2361 1.762L9.55852 1.61532C9.48115 1.61371 9.41828 1.54762 9.42151 1.47026C9.42473 1.39289 9.49243 1.33486 9.56819 1.33325L14.3779 1.48315C14.452 1.48476 14.5117 1.54601 14.5149 1.62016L14.6648 6.43148C14.668 6.50885 14.6052 6.57493 14.5278 6.57655H14.523H14.5246Z" fill="black" stroke="black"/>
      <path d="M6.57172 6.71185C6.53626 6.71185 6.49919 6.69735 6.47179 6.66995L1.57504 1.7732C1.52023 1.71839 1.52023 1.62813 1.57504 1.57333C1.62984 1.51853 1.7201 1.51853 1.7749 1.57333L6.67165 6.47008C6.72646 6.52488 6.72646 6.61514 6.67165 6.66995C6.64425 6.69735 6.60718 6.71185 6.57172 6.71185Z" fill="black" stroke="black"/>
      <path d="M1.47521 6.57655H1.47038C1.39301 6.57493 1.33015 6.50885 1.33337 6.43148L1.48327 1.62016C1.48488 1.54601 1.54614 1.48476 1.62028 1.48315L6.42999 1.33325C6.51058 1.33325 6.57344 1.39128 6.57506 1.47026C6.57828 1.54924 6.51702 1.61371 6.43805 1.61532L1.76051 1.762L1.61544 6.43954C1.61222 6.5153 1.55097 6.57655 1.4736 6.57655" fill="black"/>
      <path d="M1.47521 6.57655H1.47038C1.39301 6.57493 1.33015 6.50885 1.33337 6.43148L1.48327 1.62016C1.48488 1.54601 1.54614 1.48476 1.62028 1.48315L6.42999 1.33325C6.51058 1.33325 6.57344 1.39128 6.57506 1.47026C6.57828 1.54924 6.51702 1.61371 6.43804 1.61532L1.76051 1.762L1.61544 6.43954C1.61222 6.5153 1.55097 6.57655 1.4736 6.57655" stroke="black"/>
      <path d="M1.67497 14.2343C1.63951 14.2343 1.60244 14.2198 1.57504 14.1924C1.52023 14.1376 1.52023 14.0473 1.57504 13.9925L6.47179 9.09579C6.52659 9.04099 6.61685 9.04099 6.67165 9.09579C6.72646 9.15059 6.72646 9.24086 6.67165 9.29566L1.7749 14.1924C1.7475 14.2198 1.71204 14.2343 1.67497 14.2343Z" fill="black" stroke="black"/>
      <path d="M6.43654 14.4342H6.4317L1.62199 14.2843C1.54785 14.2827 1.48659 14.2215 1.48498 14.1473L1.33508 9.33598C1.33186 9.25861 1.3931 9.19253 1.47208 9.19092C1.54462 9.19092 1.61554 9.25055 1.61715 9.32792L1.76222 14.0055L6.43976 14.1505C6.51712 14.1538 6.57999 14.2182 6.57677 14.2972C6.57354 14.373 6.51229 14.4342 6.43493 14.4342" fill="black"/>
      <path d="M6.43654 14.4342H6.4317L1.62199 14.2843C1.54785 14.2827 1.48659 14.2215 1.48498 14.1473L1.33508 9.33598C1.33186 9.25861 1.3931 9.19253 1.47208 9.19092C1.54462 9.19092 1.61554 9.25055 1.61715 9.32792L1.76222 14.0055L6.43976 14.1505C6.51712 14.1538 6.57999 14.2182 6.57677 14.2972C6.57354 14.373 6.51229 14.4342 6.43493 14.4342" stroke="black"/>
      <path d="M14.3247 14.2343C14.2892 14.2343 14.2521 14.2198 14.2247 14.1924L9.32797 9.29566C9.27316 9.24086 9.27316 9.15059 9.32797 9.09579C9.38277 9.04099 9.47303 9.04099 9.52783 9.09579L14.4246 13.9925C14.4794 14.0473 14.4794 14.1376 14.4246 14.1924C14.3972 14.2198 14.3601 14.2343 14.3247 14.2343Z" fill="black" stroke="black"/>
      <path d="M9.56506 14.4342C9.4893 14.4342 9.42644 14.373 9.42322 14.2972C9.41999 14.2198 9.48125 14.1538 9.56023 14.1505L14.2378 14.0055L14.3844 9.32792C14.3877 9.25055 14.4473 9.19092 14.5295 9.19092C14.6069 9.19414 14.6697 9.25861 14.6665 9.33598L14.5166 14.1473C14.5134 14.2215 14.4538 14.2827 14.3796 14.2843L9.5699 14.4342H9.56506Z" fill="black" stroke="black"/>`
    controlUI.appendChild(controlIcon)

    const controlText = document.createElement('div')
    controlText.style.color = 'rgb(25,25,25)'
    controlText.style.fontFamily = 'Open Sans, sans-serif'
    controlText.style.fontSize = '14px'
    controlText.style.lineHeight = '24px'
    controlText.style.textAlign = 'center'
    controlText.style.fontWeight = '600'
    controlText.style.marginLeft = '5px'
    controlText.innerHTML = mapZoomTextIn
    controlUI.appendChild(controlText)

    const googleMap = document.querySelector('#map')

    controlUI.addEventListener('click', () => {
      if (canGoFullscreen()) {
        if (!document.fullscreenElement) {
          googleMap.requestFullscreen()
        } else {
          if (document.exitFullscreen) {
            document.exitFullscreen()
          }
        }
      } else {
        if (!googleMap.classList.contains('fixed-fullscreen-map')) {
          controlText.innerHTML = mapZoomTextOut
          controlIcon.setAttributeNS(null, 'viewBox', '0 0 13 11')
          controlIcon.setAttributeNS(null, 'width', '13')
          controlIcon.setAttributeNS(null, 'height', '11')
          controlIcon.innerHTML = '<path d="M1.492 1.984a.492.492 0 1 1 0-.984.492.492 0 0 1 0 .984zM4.865 1h6.713a.492.492 0 0 1 0 .984H4.865a.492.492 0 0 1 0-.984zM1.492 5.919a.492.492 0 1 1 0-.984.492.492 0 0 1 0 .984zm3.373-.984h6.713a.492.492 0 0 1 0 .984H4.865a.492.492 0 0 1 0-.984zM1.492 9.854a.492.492 0 1 1 0-.984.492.492 0 0 1 0 .984zm3.373-.984h6.713a.492.492 0 0 1 0 .984H4.865a.492.492 0 1 1 0-.984z" fill="#4a4a4a" stroke="#4a4a4a" stroke-width=".6" fill-rule="evenodd"></path>'

          googleMap.classList.add('fixed-fullscreen-map')
        } else {
          controlText.innerHTML = mapZoomTextIn
          controlIcon.setAttributeNS(null, 'viewBox', `0 0 ${boxWidth} ${boxHeight}`)
          controlIcon.setAttributeNS(null, 'width', boxWidth)
          controlIcon.setAttributeNS(null, 'height', boxHeight)
          controlIcon.innerHTML = `
            <path d="M9.42962 6.71185C9.39416 6.71185 9.35708 6.69735 9.32968 6.66995C9.27487 6.61514 9.27487 6.52488 9.32968 6.47008L14.2264 1.57333C14.2812 1.51853 14.3715 1.51853 14.4263 1.57333C14.4811 1.62813 14.4811 1.71839 14.4263 1.7732L9.52955 6.66995C9.50215 6.69735 9.46508 6.71185 9.42962 6.71185Z" fill="black" stroke="black"/>
            <path d="M14.5246 6.57655C14.4488 6.57655 14.386 6.5153 14.3827 6.43954L14.2361 1.762L9.55852 1.61532C9.48115 1.61371 9.41828 1.54762 9.42151 1.47026C9.42473 1.39289 9.49243 1.33486 9.56819 1.33325L14.3779 1.48315C14.452 1.48476 14.5117 1.54601 14.5149 1.62016L14.6648 6.43148C14.668 6.50885 14.6052 6.57493 14.5278 6.57655H14.523H14.5246Z" fill="black" stroke="black"/>
            <path d="M6.57172 6.71185C6.53626 6.71185 6.49919 6.69735 6.47179 6.66995L1.57504 1.7732C1.52023 1.71839 1.52023 1.62813 1.57504 1.57333C1.62984 1.51853 1.7201 1.51853 1.7749 1.57333L6.67165 6.47008C6.72646 6.52488 6.72646 6.61514 6.67165 6.66995C6.64425 6.69735 6.60718 6.71185 6.57172 6.71185Z" fill="black" stroke="black"/>
            <path d="M1.47521 6.57655H1.47038C1.39301 6.57493 1.33015 6.50885 1.33337 6.43148L1.48327 1.62016C1.48488 1.54601 1.54614 1.48476 1.62028 1.48315L6.42999 1.33325C6.51058 1.33325 6.57344 1.39128 6.57506 1.47026C6.57828 1.54924 6.51702 1.61371 6.43805 1.61532L1.76051 1.762L1.61544 6.43954C1.61222 6.5153 1.55097 6.57655 1.4736 6.57655" fill="black"/>
            <path d="M1.47521 6.57655H1.47038C1.39301 6.57493 1.33015 6.50885 1.33337 6.43148L1.48327 1.62016C1.48488 1.54601 1.54614 1.48476 1.62028 1.48315L6.42999 1.33325C6.51058 1.33325 6.57344 1.39128 6.57506 1.47026C6.57828 1.54924 6.51702 1.61371 6.43804 1.61532L1.76051 1.762L1.61544 6.43954C1.61222 6.5153 1.55097 6.57655 1.4736 6.57655" stroke="black"/>
            <path d="M1.67497 14.2343C1.63951 14.2343 1.60244 14.2198 1.57504 14.1924C1.52023 14.1376 1.52023 14.0473 1.57504 13.9925L6.47179 9.09579C6.52659 9.04099 6.61685 9.04099 6.67165 9.09579C6.72646 9.15059 6.72646 9.24086 6.67165 9.29566L1.7749 14.1924C1.7475 14.2198 1.71204 14.2343 1.67497 14.2343Z" fill="black" stroke="black"/>
            <path d="M6.43654 14.4342H6.4317L1.62199 14.2843C1.54785 14.2827 1.48659 14.2215 1.48498 14.1473L1.33508 9.33598C1.33186 9.25861 1.3931 9.19253 1.47208 9.19092C1.54462 9.19092 1.61554 9.25055 1.61715 9.32792L1.76222 14.0055L6.43976 14.1505C6.51712 14.1538 6.57999 14.2182 6.57677 14.2972C6.57354 14.373 6.51229 14.4342 6.43493 14.4342" fill="black"/>
            <path d="M6.43654 14.4342H6.4317L1.62199 14.2843C1.54785 14.2827 1.48659 14.2215 1.48498 14.1473L1.33508 9.33598C1.33186 9.25861 1.3931 9.19253 1.47208 9.19092C1.54462 9.19092 1.61554 9.25055 1.61715 9.32792L1.76222 14.0055L6.43976 14.1505C6.51712 14.1538 6.57999 14.2182 6.57677 14.2972C6.57354 14.373 6.51229 14.4342 6.43493 14.4342" stroke="black"/>
            <path d="M14.3247 14.2343C14.2892 14.2343 14.2521 14.2198 14.2247 14.1924L9.32797 9.29566C9.27316 9.24086 9.27316 9.15059 9.32797 9.09579C9.38277 9.04099 9.47303 9.04099 9.52783 9.09579L14.4246 13.9925C14.4794 14.0473 14.4794 14.1376 14.4246 14.1924C14.3972 14.2198 14.3601 14.2343 14.3247 14.2343Z" fill="black" stroke="black"/>
            <path d="M9.56506 14.4342C9.4893 14.4342 9.42644 14.373 9.42322 14.2972C9.41999 14.2198 9.48125 14.1538 9.56023 14.1505L14.2378 14.0055L14.3844 9.32792C14.3877 9.25055 14.4473 9.19092 14.5295 9.19092C14.6069 9.19414 14.6697 9.25861 14.6665 9.33598L14.5166 14.1473C14.5134 14.2215 14.4538 14.2827 14.3796 14.2843L9.5699 14.4342H9.56506Z" fill="black" stroke="black"/>`

          googleMap.classList.remove('fixed-fullscreen-map')
        }
      }
    })

    document.onfullscreenchange = () => {
      if (!document.fullscreenElement) {
        controlText.innerHTML = mapZoomTextIn
        controlIcon.setAttributeNS(null, 'viewBox', `0 0 ${boxWidth} ${boxHeight}`)
        controlIcon.setAttributeNS(null, 'width', boxWidth)
        controlIcon.setAttributeNS(null, 'height', boxHeight)
        controlIcon.innerHTML = `
          <path d="M9.42962 6.71185C9.39416 6.71185 9.35708 6.69735 9.32968 6.66995C9.27487 6.61514 9.27487 6.52488 9.32968 6.47008L14.2264 1.57333C14.2812 1.51853 14.3715 1.51853 14.4263 1.57333C14.4811 1.62813 14.4811 1.71839 14.4263 1.7732L9.52955 6.66995C9.50215 6.69735 9.46508 6.71185 9.42962 6.71185Z" fill="black" stroke="black"/>
          <path d="M14.5246 6.57655C14.4488 6.57655 14.386 6.5153 14.3827 6.43954L14.2361 1.762L9.55852 1.61532C9.48115 1.61371 9.41828 1.54762 9.42151 1.47026C9.42473 1.39289 9.49243 1.33486 9.56819 1.33325L14.3779 1.48315C14.452 1.48476 14.5117 1.54601 14.5149 1.62016L14.6648 6.43148C14.668 6.50885 14.6052 6.57493 14.5278 6.57655H14.523H14.5246Z" fill="black" stroke="black"/>
          <path d="M6.57172 6.71185C6.53626 6.71185 6.49919 6.69735 6.47179 6.66995L1.57504 1.7732C1.52023 1.71839 1.52023 1.62813 1.57504 1.57333C1.62984 1.51853 1.7201 1.51853 1.7749 1.57333L6.67165 6.47008C6.72646 6.52488 6.72646 6.61514 6.67165 6.66995C6.64425 6.69735 6.60718 6.71185 6.57172 6.71185Z" fill="black" stroke="black"/>
          <path d="M1.47521 6.57655H1.47038C1.39301 6.57493 1.33015 6.50885 1.33337 6.43148L1.48327 1.62016C1.48488 1.54601 1.54614 1.48476 1.62028 1.48315L6.42999 1.33325C6.51058 1.33325 6.57344 1.39128 6.57506 1.47026C6.57828 1.54924 6.51702 1.61371 6.43805 1.61532L1.76051 1.762L1.61544 6.43954C1.61222 6.5153 1.55097 6.57655 1.4736 6.57655" fill="black"/>
          <path d="M1.47521 6.57655H1.47038C1.39301 6.57493 1.33015 6.50885 1.33337 6.43148L1.48327 1.62016C1.48488 1.54601 1.54614 1.48476 1.62028 1.48315L6.42999 1.33325C6.51058 1.33325 6.57344 1.39128 6.57506 1.47026C6.57828 1.54924 6.51702 1.61371 6.43804 1.61532L1.76051 1.762L1.61544 6.43954C1.61222 6.5153 1.55097 6.57655 1.4736 6.57655" stroke="black"/>
          <path d="M1.67497 14.2343C1.63951 14.2343 1.60244 14.2198 1.57504 14.1924C1.52023 14.1376 1.52023 14.0473 1.57504 13.9925L6.47179 9.09579C6.52659 9.04099 6.61685 9.04099 6.67165 9.09579C6.72646 9.15059 6.72646 9.24086 6.67165 9.29566L1.7749 14.1924C1.7475 14.2198 1.71204 14.2343 1.67497 14.2343Z" fill="black" stroke="black"/>
          <path d="M6.43654 14.4342H6.4317L1.62199 14.2843C1.54785 14.2827 1.48659 14.2215 1.48498 14.1473L1.33508 9.33598C1.33186 9.25861 1.3931 9.19253 1.47208 9.19092C1.54462 9.19092 1.61554 9.25055 1.61715 9.32792L1.76222 14.0055L6.43976 14.1505C6.51712 14.1538 6.57999 14.2182 6.57677 14.2972C6.57354 14.373 6.51229 14.4342 6.43493 14.4342" fill="black"/>
          <path d="M6.43654 14.4342H6.4317L1.62199 14.2843C1.54785 14.2827 1.48659 14.2215 1.48498 14.1473L1.33508 9.33598C1.33186 9.25861 1.3931 9.19253 1.47208 9.19092C1.54462 9.19092 1.61554 9.25055 1.61715 9.32792L1.76222 14.0055L6.43976 14.1505C6.51712 14.1538 6.57999 14.2182 6.57677 14.2972C6.57354 14.373 6.51229 14.4342 6.43493 14.4342" stroke="black"/>
          <path d="M14.3247 14.2343C14.2892 14.2343 14.2521 14.2198 14.2247 14.1924L9.32797 9.29566C9.27316 9.24086 9.27316 9.15059 9.32797 9.09579C9.38277 9.04099 9.47303 9.04099 9.52783 9.09579L14.4246 13.9925C14.4794 14.0473 14.4794 14.1376 14.4246 14.1924C14.3972 14.2198 14.3601 14.2343 14.3247 14.2343Z" fill="black" stroke="black"/>
          <path d="M9.56506 14.4342C9.4893 14.4342 9.42644 14.373 9.42322 14.2972C9.41999 14.2198 9.48125 14.1538 9.56023 14.1505L14.2378 14.0055L14.3844 9.32792C14.3877 9.25055 14.4473 9.19092 14.5295 9.19092C14.6069 9.19414 14.6697 9.25861 14.6665 9.33598L14.5166 14.1473C14.5134 14.2215 14.4538 14.2827 14.3796 14.2843L9.5699 14.4342H9.56506Z" fill="black" stroke="black"/> `
      } else {
        if (document.exitFullscreen) {
          controlText.innerHTML = mapZoomTextOut
          controlIcon.setAttributeNS(null, 'viewBox', '0 0 13 11')
          controlIcon.setAttributeNS(null, 'width', '13')
          controlIcon.setAttributeNS(null, 'height', '11')
          controlIcon.innerHTML = '<path d="M1.492 1.984a.492.492 0 1 1 0-.984.492.492 0 0 1 0 .984zM4.865 1h6.713a.492.492 0 0 1 0 .984H4.865a.492.492 0 0 1 0-.984zM1.492 5.919a.492.492 0 1 1 0-.984.492.492 0 0 1 0 .984zm3.373-.984h6.713a.492.492 0 0 1 0 .984H4.865a.492.492 0 0 1 0-.984zM1.492 9.854a.492.492 0 1 1 0-.984.492.492 0 0 1 0 .984zm3.373-.984h6.713a.492.492 0 0 1 0 .984H4.865a.492.492 0 1 1 0-.984z" fill="#4a4a4a" stroke="#4a4a4a" stroke-width=".6" fill-rule="evenodd"></path>'
        }
      }
    }
  }

  GmapObject.load().then((google) => {
    const centerLat = pathOr(37.4419, ['centerLatitude'], destinationMapSettings)
    const centerLon = pathOr(-122.1419, ['centerLongitude'], destinationMapSettings)
    const zoom = pathOr(3, ['centerZoom'], destinationMapSettings)
    const center = new google.maps.LatLng(centerLat, centerLon)

    map = new google.maps.Map(destinationMap, {
      zoom: parseInt(zoom, 10),
      center,
      mapId: mapIDs.default_interactive,
      disableDefaultUI: true,
      fullscreenControl: false,
      streetViewControlOptions: {
        position: google.maps.ControlPosition.RIGHT_BOTTOM,
      },
    })

    const infowindow = new google.maps.InfoWindow()
    const markers = []
    const bounds = new google.maps.LatLngBounds()
    const links = $('span[data-categories]')

    google.maps.event.addListener(infowindow, 'domready', () => {
      const iwOuter = $('.gm-style-iw')
      const iwBackground = iwOuter.prev()

      iwBackground.children(':nth-child(2)').css({ 'border-radius': '12px' })
      iwBackground.children(':nth-child(4)').css({ 'border-radius': '12px' })
    })

    function drawPopup(markerObj) {
      const pinElement = getPinSVG();
      const latLng = new google.maps.LatLng(markerObj.latitude,
        markerObj.longitude)

      const marker = new google.maps.marker.AdvancedMarkerElement({
        position: {
          lat: markerObj.latitude,
          lng: markerObj.longitude,
        },
        content: pinElement,
        gmpClickable: true,
        map,
      })

      bounds.extend(new google.maps.LatLng(markerObj.latitude, markerObj.longitude))

      marker.addListener('click', (e) => {
        markers.forEach(el => {
          el.targetElement.classList.remove('active')
        })
        e.domEvent.currentTarget.classList.add('active');

        const linksPush = document.getElementsByClassName('mapLinks')
        infowindow.setContent(`${"<div class='tooltip-destination'>"
        + "<div class='tooltip-destination__image' style='background-image:url("}${markerObj.img})';></div>`
        + '<div class=\'tooltip-destination__description\'>'
        + '<div class=\'tooltip-destination__ft\'>'
        + `<span><a class='mapLinks' href='${markerObj.tags[0].url}'>${markerObj.tags[0].text}</a></span>`
        + `<span><a class='mapLinks' href='${markerObj.tags[1].url}'>${markerObj.tags[1].text}</a></span>`
        + '</div>'
        + `<div class='tooltip-destination__head'><a href='${markerObj.title.url}'>${markerObj.title.text}</a><div class="tooltip-destination__stars star${markerObj.stars}"></div></div>`
        + `<div class='tooltip-destination__availability'><a class='mapLinks' href='${markerObj.availability.url}'>${markerObj.availability.text}</a></div>`
        + '</div>'
        + '</div>'
        + '</div>')
        infowindow.setOptions({
          maxWidth : 477,
          minWidth : 240
        });

        function popupPos() {
          if ($(window).width() < 1024) {
            infowindow.setOptions({
              pixelOffset: new google.maps.Size(0,390)
            })
          } else {
            infowindow.setOptions({
              pixelOffset: new google.maps.Size(259, 100)
            })
          }
        }
        popupPos()
        $(window).on('resize', popupPos)
        infowindow.open(map, marker)

        google.maps.event.addListener(infowindow,'closeclick',function(){
          marker.targetElement.classList.remove('active')
        });

        const mapWrapper = document.getElementById(markerObj.mapId)
        const mapWidget = mapWrapper ? mapWrapper.closest('.gmap-widget') : null;
        var passiveSupported = false;
        try {
            window.addEventListener(
                "test",
                null,
                Object.defineProperty({}, "passive", { get: function() { passiveSupported = true; } }));
        } catch(err) {};

        const clickMark = 'ontouchstart' in window ? 'mark_selected' : 'click'
        if (mapWidget) {
          mapWidget.addEventListener(clickMark, () => {
              mapWidget.classList.add('show-autocomplete')
            }
            ,passiveSupported ? { passive: true } : false
          )
          mapWidget.dispatchEvent(new CustomEvent('mark_selected', {
            detail: {
              mark: markerObj,
            },
          }))
        }

        setTimeout(() => {
          Array.from(linksPush).forEach((link) => {
            link.addEventListener('click', pushDestinationMapLinks, false)
          })
        }, 100)

        pushDestinationMapMarker()
      })

      bounds.extend(latLng)
      markers.push(marker)
    }

    // Create tooltip
    destinationMapSettings.markers.map(marker => drawPopup(marker))

    // Styles tooltip
    const mcOptions = {
      minimumClusterSize: 10000000,
      styles: [{
        url: generateSvgBtoa('<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="39" height="47"><defs><path id="a" d="M696.53 378.77a19.16 19.16 0 1 1 38.32 0 19.16 19.16 0 1 1-38.32 0z"/><path id="b" d="M708.85 396.56l6.88 9.64 6.8-9.64z"/><path id="c" d="M696.53 378.77a19.16 19.16 0 1 1 38.32 0 19.16 19.16 0 1 1-38.32 0z"/><clipPath id="d"><use fill="#fff" xlink:href="#a"/></clipPath></defs><use fill="#ec004a" xlink:href="#b" transform="translate(-696 -359)"/><g fill="#fff" transform="translate(-696 -359)"><use xlink:href="#c"/><use fill-opacity="0" stroke="#ec004a" stroke-miterlimit="50" stroke-width="10" clip-path="url(&quot;#d&quot;)" xlink:href="#c"/></g></svg>'),
        width: 39,
        height: 47,
        textSize: 12,
        textColor: '#4a4a4a',
        anchor: [13, 0],
      }],
    }

    // Change location markers
    // const markerCluster = new MarkerClusterer(map, markers, mcOptions)

    function filterMarkers(e) {
      e.preventDefault()
      const linkCategories = String($(this).data('categories')).split(' ')
      const filteredBounds = new google.maps.LatLngBounds()
      destinationMapSettings.markers.forEach((marker) => {
        if (marker.categories.find(category => linkCategories.indexOf(String(category)) !== -1)) {
          filteredBounds.extend(new google.maps.LatLng(marker.latitude, marker.longitude))
        }
      })
      map.fitBounds(filteredBounds)
    }

    // custom controls for map
    function initZoomControl(map) {
      const zoomIn = document.querySelector('.zoom-control-in')
      const zoomOut = document.querySelector('.zoom-control-out')
      const zoomControl = document.querySelector('.zoom-control')
      if (zoomIn) {
        zoomIn.onclick = function () {
          map.setZoom(map.getZoom() + 1)
        }
      }
      if (zoomOut) {
        zoomOut.onclick = function () {
          map.setZoom(map.getZoom() - 1)
        }
      }
      if (zoomControl) {
        map.controls[google.maps.ControlPosition.RIGHT_BOTTOM].push(zoomControl)
      }
    }

    const centerControlDiv = document.createElement('div')
    CenterControl(centerControlDiv, map)
    map.controls[google.maps.ControlPosition.RIGHT_TOP].push(centerControlDiv)

    initZoomControl(map)

    links.on('click', filterMarkers)
  })
}
